/*******************************************************************************
TRIGGER THE SELECTED TAB
Activates the tab that is designated as the selected one for the current screen size.
*******************************************************************************/

// https://www.npmjs.com/package/idb-keyval
import { Store, get } from '../../../lib/_idb-keyval/idb-keyval';

import getBreakpointData from '../breakpoints/get-data';
import switchTab from './switch-tab';

async function getTabThatShouldBeSelected(tabSetName) {

    // Check for saved preference in IndexDB first
    const rwStore = new Store('rotowire', 'toggletabs');
    const savedSelectedTab = await get(tabSetName, rwStore).then(val => val);
    if (savedSelectedTab) { return savedSelectedTab; }

    // Get the breakpoint data
    const { order: breakpoints, currentIndex: currentBPindex } = getBreakpointData();

    // Get the data attributes and filter them down to just the breakpoint-related values
    const $tabSet = $(`.toggle-tabs[data-name="${tabSetName}"]`);
    const tabSetDataAttr = $tabSet.data() || {};
    const bpSelections = Object.keys(tabSetDataAttr)
        .filter(key => key.includes('sel') && !key.includes('Exists'))
        .reduce((obj, key) => {
            const newKey = key.replace('sel', '', key).toLowerCase();
            obj[newKey] = tabSetDataAttr[key];
            return obj;
        }, {});

    // Find all the breakpoints at or below the current one (order from largest screen to smallest)
    const relevantBreakpoints = breakpoints.filter((bp, index) => index <= currentBPindex).reverse();

    // Filter that list down to only breakpoints that have selected tab values (it's possible there are none)
    const bpWithSelectedTabs = relevantBreakpoints.filter(bp => bpSelections.hasOwnProperty(bp));

    // Find the correct selected tab for this breakpoint by using the largest matching breakpoint value
    // If no matching breakpoint was found, then default to the xxs value (which is always there)
    return (bpWithSelectedTabs.length > 0) ? bpSelections[bpWithSelectedTabs[0]] : bpSelections.xxs;
}

// Figure out the correct selected tab and activate it
async function setSelectedTab(tabSetName) {
    const selectedTab = await getTabThatShouldBeSelected(tabSetName);
    switchTab(tabSetName, selectedTab);
}

export default function triggerSelectedTab(tabSetName) {

    // If we have a specific tab set, activate its selected tab
    if (tabSetName) { return setSelectedTab(tabSetName); }

    // If we don't have a specific tab set, then we know we need to loop through all of them
    $('.toggle-tabs').filter(':visible').each(function loopAllSets() { setSelectedTab($(this).data('name')); });

    $('.toggle-tabs').each(function() { 
        if ($(this).data("alwaysop") == 1) {
            setSelectedTab($(this).data('name')); 
        }
    });
}
